"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleEditViewModel = instanceOfRoleEditViewModel;
exports.RoleEditViewModelFromJSON = RoleEditViewModelFromJSON;
exports.RoleEditViewModelFromJSONTyped = RoleEditViewModelFromJSONTyped;
exports.RoleEditViewModelToJSON = RoleEditViewModelToJSON;
exports.RoleEditViewModelToJSONTyped = RoleEditViewModelToJSONTyped;
/**
 * Check if a given object implements the RoleEditViewModel interface.
 */
function instanceOfRoleEditViewModel(value) {
    return true;
}
function RoleEditViewModelFromJSON(json) {
    return RoleEditViewModelFromJSONTyped(json, false);
}
function RoleEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ugNo': json['ugNo'] == null ? undefined : json['ugNo'],
        'ugName': json['ugName'] == null ? undefined : json['ugName'],
        'ugSys': json['ugSys'] == null ? undefined : json['ugSys'],
        'ugActive': json['ugActive'] == null ? undefined : json['ugActive'],
    };
}
function RoleEditViewModelToJSON(json) {
    return RoleEditViewModelToJSONTyped(json, false);
}
function RoleEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ugNo': value['ugNo'],
        'ugName': value['ugName'],
        'ugSys': value['ugSys'],
        'ugActive': value['ugActive'],
    };
}
